export default __webpack_public_path__ + "static/media/ritual-make4.bda09614.png";